import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HotelSummary, Token } from '../types/embed';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppService {
    constructor(private http: HttpClient) {}

    public getEmbedToken(hostToken: string, collectionToken: string): Observable<Token> {
        return this.http.get<Token>(
            this.resolveUrl(`/embed/${hostToken}/${collectionToken}/embed-token`)
        );
    }

    public getCanvasDashboards(hostToken: string, hotelToken: string): Observable<HotelSummary> {
        return this.http.get<HotelSummary>(
            this.resolveUrl(`/embed/${hostToken}/hotel/${hotelToken}/dashboards`)
        );
    }

    public getClusterDashboards(hostToken: string, clusterToken: string): Observable<HotelSummary> {
        return this.http.get<HotelSummary>(
            this.resolveUrl(`/embed/${hostToken}/cluster/${clusterToken}/dashboards`)
        );
    }

    private resolveUrl(url: string): string {
        return `${environment.api_url}${url}`;
    }
}
